import { bool, func, number, oneOf, object } from 'prop-types'
import { Component } from 'react'
import { Asset } from '@opallabs/cassini'
import {
  Asset as KuiperAsset,
  Lightbox,
  kuiperClassNames,
} from '@opallabs/kuiper'

import './styles.scss'

const alignmentMap = {
  center: 'contain',
  fit: 'fill',
  fill: 'cover',
}

class ImageSlideAsset extends Component {
  static propTypes = {
    alignment: oneOf(['center', 'fit', 'fill']),
    assetReference: object,
    onDelete: func,
    presentationId: number,
    slideId: number,
    thumbnail: bool,
    updateSlide: func,
    viewOnlyMode: bool,
  }

  static defaultProps = {
    alignment: 'center',
    onDelete: () => {},
    thumbnail: false,
    viewOnlyMode: false,
  }

  constructor(props) {
    super(props)
    this.state = {
      lightboxVisible: false,
    }
  }

  toggleLightbox = () => {
    this.setState((prevState) => ({
      lightboxVisible: !prevState.lightboxVisible,
    }))
  }

  onDelete = () => {
    const { presentationId, slideId, updateSlide } = this.props
    const changes = { canvas_asset_reference_id: null }
    updateSlide(presentationId, slideId, changes)

    this.props.onDelete()
  }

  render() {
    return (
      <div className={kuiperClassNames('image-slide-asset')}>
        <KuiperAsset
          assetReference={this.props.assetReference}
          deletable={!this.props.viewOnlyMode}
          downloadable={true}
          editable={false}
          editing={false}
          embiggenable={true}
          imageFit={alignmentMap[this.props.alignment]}
          hasImageOverlay={!this.props.thumbnail}
          thumbnail={this.props.thumbnail}
          hasTools={true}
          onDelete={this.onDelete}
          onEmbiggen={this.toggleLightbox}
          removeable={false}
        />
        <Lightbox
          visible={this.state.lightboxVisible}
          onClose={this.toggleLightbox}
        >
          <Asset assetReference={this.props.assetReference} />
        </Lightbox>
      </div>
    )
  }
}

export default ImageSlideAsset
